import React from "react";
import styled from "styled-components";

import {MainLayout} from "layouts";
import Button from "components/ui/Button";
import iconNoPartner from "assets/icons/icon_no_partner.svg";
import useKakaoChannel from "hooks/useKakaoChannel";

export const NoPartner = () => {
  const { handleClickOpenKakao } = useKakaoChannel();

	return (
		<MainLayout
			withHeader={false}
			backgroundColor="white"
			headerProps={{
				withBackButton : false
			}}
		>
			<Wrapper>
				<div className="top">
					<h2>
						관리자로 등록된<br />
						센터가 없어요
					</h2>
					<h5>
						관리자앱 사용을 원하시면<br />
						대표 관리자에게 문의해주세요
					</h5>
				</div>
				<div className="middle">
					<img src={iconNoPartner} />
				</div>
				<div className="bottom">
					<p>더 궁금한 사항은 바디코디에 문의해주세요 </p>
					<Button color="blue" outline onClick={handleClickOpenKakao}>바디코디 문의하기</Button>
				</div>
			</Wrapper>
		</MainLayout>
	);
};

const Wrapper = styled.div`
&			{position:fixed; left:0; top:0; right:0; bottom:0;
			 padding:72px 24px 96px 24px; background-color:white;
			 display:flex; flex-direction:column; box-sizing:border-box; z-index:8}
.top		{}
.top h5		{margin-top:12px; line-height:1.5}
.middle		{display:flex; flex:1; padding:80px 0; align-items:center; justify-content:center}
.bottom		{}
.bottom	p	{margin-bottom:12px; text-align:center; color:#949db2}
.bottom button	{font-weight:600}
`;

export default NoPartner;